export default __webpack_public_path__ + "images/calendar.578c2f29e611894ac6a89f2b31efe192.svg";